import { EnvironmentModel } from "src/app/services/environment.service";


export const environment: EnvironmentModel = {
  production: false,
  baseUrl: 'https://api.catnw8-knorrbrem1-d2-public.model-t.cc.commerce.ondemand.com/',
  naStoreUrl: 'https://dev2.b2bendix.com',
  emeaStoreUrl: 'https://dev2-mytruckservices.knorr-bremse.com',
  apacStoreUrl: 'https://dev2-apac-cvs.knorr-bremse.com',
  googleReCaptchaKey: '6LdC4kkqAAAAAEuDmkMpP4hf-E6k_6pjmYABn_LG',
  oneTrustKey: '9c35cb4f-f1c2-40af-9af4-59b11f785f37-test',
  webtrekk: {
    trackId: "300480523804340",
    trackDomain: "knorrbremseglobal01.wt-eu02.net"
  },
  serverLoggingUrl: 'https://api-qa2.b2bendix.comocc/v2/NA/ui-logs'
};
